export default "__VITE_ASSET__66698180__"